<template>
  <div class="active-projects">
    <projects
      :project-data="activeProjects"
      :show-toolbar="true"
      :show-title="true"
      title="Active Projects"
      :show-search="true"
      :show-view-toggle="false"
      :show-sort-filter="true"
      :show-filters="false"
      :show-display-count="false"
      :show-create-new="false"
      :show-completed-projects="false"
      :default-view-mode="'list'"
      :per-page="5"
      :disable-preferences="true"
      :columns="tableColumns"
    />
  </div>
</template>

<script>
import Projects from './Projects.vue';

export default {
  name: 'ActiveProjects',

  components: {
    Projects
  },

  props: {
    projects: {
      type: Array,
      required: true
    }
  },

  computed: {
    activeProjects() {
      // Filter only active projects
      return this.projects.filter(project => project.status === 'Active');
    },

    tableColumns() {
      // Custom columns for active projects view
      return [
        {
          field: 'priority',
          label: 'Priority',
          sortable: true,
          align: 'center',
          width: '100px',
          formatter: (value) => {
            const priority = value || 'MEDIUM';
            const colorClass = this.getPriorityColorClass(priority);
            return `<span class="badge ${colorClass}">${priority}</span>`;
          }
        },
        {
          field: 'name',
          label: 'Name',
          sortable: true,
          searchable: true,
          align: 'left',
          formatter: (value, row) => {
            return `<a href="${row.view_url}" class="active-projects__name-link">${value}</a>`;
          }
        },
        {
          field: 'stage',
          label: 'Stage',
          sortable: true,
          searchable: true,
          formatter: (value) => {
            const badgeClass = this.getStageBadgeClass(value);
            return `<span class="badge ${badgeClass}">${value}</span>`;
          }
        },
        {
          field: 'end_date_formatted',
          label: 'End Date',
          sortable: true,
          align: 'right'
        }
      ];
    }
  },

  methods: {
    getPriorityColorClass(priority) {
      if (!priority) return 'badge--blue';
      
      const priorityLower = priority.toLowerCase();
      
      if (priorityLower === 'high' || priorityLower === 'critical') {
        return 'badge--red';
      } else if (priorityLower === 'medium') {
        return 'badge--yellow';
      } else if (priorityLower === 'low') {
        return 'badge--green';
      }
      
      return 'badge--blue';
    },

    getStageBadgeClass(stage) {
      if (!stage) return 'badge--blue';
      
      const stageLower = stage.toLowerCase();
      
      if (stageLower.includes('complete') || stageLower.includes('closed')) {
        return 'badge--green';
      } else if (stageLower.includes('active') || stageLower.includes('in progress')) {
        return 'badge--blue';
      } else if (stageLower.includes('pending') || stageLower.includes('review')) {
        return 'badge--yellow';
      } else if (stageLower.includes('cancelled') || stageLower.includes('on hold')) {
        return 'badge--red';
      } else if (stageLower.includes('planning') || stageLower.includes('draft')) {
        return 'badge--purple';
      }
      
      return 'badge--blue';
    }
  }
};
</script>
